//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format } from "date-fns";

export default {
	name: "BlogCard",
	props: {
		blog: Object,
		isCategoryPage: Boolean,
	},
	data() {
		return {}
	},
	computed: {
		dateDisplay() {
			return format(new Date(this.blog.blogDate), "MMMM dd, yyyy");
		},
		datetimeAttr() {
			return format(new Date(this.blog.blogDate), "yyyy-MM-dd");
		},
		truncatedDescription() {
			if (!this.blog.pageCopyHtml) return "";
			let descHtmlDiv = document.createElement("div");
			descHtmlDiv.classList.add("blog-card__description--hidden");
			descHtmlDiv.innerHTML = this.blog.pageCopyHtml;
			document.querySelector(".page").appendChild(descHtmlDiv);
			let string;
			if (this.isCategoryPage) {
				string = descHtmlDiv.textContent.substring(0, 84);
			} else {
				string = descHtmlDiv.textContent.substring(0, 120);
			}
			descHtmlDiv.remove();
			return string;
		},
	},
	methods: {
		categoryHref(cat) {
			return `/tank-talk/categories-page/?category=${encodeURI(cat)}/` 
		}
	},
}
